/// <reference path='../../../../typings/index.d.ts' />
/// <reference path='controls.module.ts' />

module Meevo.Components.Controls {
    'use strict';

    export class MeevoTimeRange implements angular.IDirective {
        require = 'ngModel';
        scope = {
            ngModel: '=ngModel',
            showAmPm: '=?',
            contentKeyStart: '@',
            contentKeyEnd: '@',
            disabled: '=ngDisabled',
            changed: '&ngChange',
            tabIndex: '=tabIndex',
            rangeValidation: '=?',
            invalidRanges: '=?',
            invalidSkipIndex: '=?',
            maxTime: '=?',
            minTime: '=?',
            allMin: '=?',
            layoutType: '@?'
        };

        templateUrl = 'app/components/controls/timeRangeTemplate.html';

        link = (scope: any, element: JQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController, $rootScope: angular.IRootScopeService) => {
            let that = this;

            scope.validateTimeRange = function () {
                //scope.ngModel.startDateTime = scope.ngModel.startDateTime || scope.ngModel.clockDate;
                //scope.ngModel.endDateTime = scope.ngModel.endDateTime || scope.ngModel.clockDate;
                let valid = true;
                scope.ngModel.startDateTime = scope.ngModel.startDateTime || scope.ngModel.clockDate;
                scope.ngModel.endDateTime = scope.ngModel.endDateTime || scope.ngModel.clockDate;
                if (scope.ngModel.startDateTime >= scope.ngModel.endDateTime) valid = false;
                if (scope.minTime && scope.maxTime) {
                    if (scope.ngModel.startDateTime <= scope.minTime ||
                        scope.ngModel.startDateTime >= scope.maxTime ||
                        scope.ngModel.endDateTime <= scope.minTime ||
                        scope.ngModel.endDateTime >= scope.maxTime) valid = false;
                }
                _.each(scope.invalidRanges, function (range: any, index: number) {
                    if (index != scope.invalidSkipIndex) {
                        if ((scope.ngModel.startDateTime >= range.startDateTime && scope.ngModel.startDateTime < range.endDateTime) ||
                            (scope.ngModel.endDateTime > range.startDateTime && scope.ngModel.endDateTime <= range.endDateTime) ||
                            (scope.ngModel.startDateTime <= range.startDateTime && scope.ngModel.endDateTime >= range.endDateTime)) valid = false;
                    }
                });

                if (valid) {
                    element.removeClass('invalid');
                }
                if (!valid) {
                    element.addClass('invalid');
                }
            }

            scope.validateTimeRange();

            scope.$watch('[ngModel.endDateTime, ngModel.startDateTime]', function () {
                that.$rootScope.$broadcast('CLOCK_CHANGE');
            });

            that.$rootScope.$on('CLOCK_CHANGE', function () {
                setTimeout(() => {
                    scope.validateTimeRange()
                }, 5)
            });
        };

        constructor(private $rootScope: angular.IRootScopeService) {
            this.$rootScope = $rootScope;
        };

        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope: angular.IRootScopeService) => {
                return new MeevoTimeRange($rootScope);
            }

            directive.$inject = ["$rootScope"];

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoTimeRange', MeevoTimeRange.factory());
}